import "./ImeiSearch.scss";

export default function ImeiSearch() {
  return (
    <section className="sales-layout__page imei-search">
      <h1>IMEI Suche</h1>
      <p>Hier werden zukünftig Artikel anhand ihrer IMEI gesucht.</p>
    </section>
  );
}
